import React, { useState, useEffect } from 'react';
import { useTheme } from '../../context/ThemeContext';
import { useAuth, useTokenPurchaseModal } from '../../context/AuthContext';
import { useTokenModal } from '../../context/TokenModalContext';
import { useTokenPurchase } from '../../hooks/useTokenPurchase';
import { getModalThemeStyles } from '../../utils/themeStyles';
import styles from '../../styles/Dialog.module.css';

const DirectTokenPurchaseModal = () => {
  const { isDarkMode } = useTheme();
  const { isAuthenticated, login } = useAuth();
  const { isOpen, onClose } = useTokenPurchaseModal();
  const { showTokenModal } = useTokenModal();
  
  const {
    formData,
    isSubmitting,
    error,
    generatedToken,
    handleSubmit,
    updateField,
    resetForm
  } = useTokenPurchase((token) => {
    console.log('Token purchase success callback with token:', token);
    // Show the token modal using the global context
    showTokenModal(token, formData.name);
    console.log('Token modal should be visible via global context');
    // Close the purchase modal after a small delay
    setTimeout(() => {
      console.log('Now closing purchase modal after delay');
      onClose(); // Close the purchase modal
    }, 100);
  });

  // Log changes to state
  useEffect(() => {
    console.log('DirectTokenPurchaseModal state update:', {
      isOpen,
      isAuthenticated,
      hasGeneratedToken: Boolean(generatedToken),
      tokenValue: generatedToken,
      stack: new Error().stack
    });
  }, [isOpen, isAuthenticated, generatedToken]);

  if (!isOpen || isAuthenticated) {
    return null;
  }

  return (
    <div
      className={styles.overlay}
      onClick={(e) => {
        e.preventDefault();
        if (!isSubmitting) onClose();
      }}
      style={getModalThemeStyles(isDarkMode)}
    >
      <div
        className={styles.dialog}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
      >
        <h2 className={styles.title}>
          OBTÉN TU TOKEN GRATUITO
        </h2>

        <div className={styles.section}>
          <div className={styles.price}>
            0,00€
            <span className={styles.highlight}>GRATIS</span>
          </div>

          <form>
            <div style={{ marginBottom: '1rem' }}>
              <label style={{ fontSize: '0.9rem', display: 'block', marginBottom: '0.5rem' }}>
                NOMBRE COMPLETO
              </label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={(e) => updateField('name', e.target.value)}
                className={styles.input}
                placeholder="Tu nombre completo"
                required
                disabled={isSubmitting}
              />
            </div>

            <div style={{ marginBottom: '1rem' }}>
              <label style={{ fontSize: '0.9rem', display: 'block', marginBottom: '0.5rem' }}>
                EMAIL
              </label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={(e) => updateField('email', e.target.value)}
                className={styles.input}
                placeholder="tu@email.com"
                required
                disabled={isSubmitting}
              />
            </div>

            {error && (
              <div
                className={styles.error}
                style={{
                  backgroundColor: '#ffebee',
                  color: '#c62828',
                  padding: '1rem',
                  marginBottom: '1rem',
                  borderRadius: '4px',
                  fontWeight: 'bold',
                  textAlign: 'left',
                  fontSize: '0.9rem',
                  lineHeight: '1.4'
                }}
              >
                <div style={{ marginBottom: '0.5rem', textTransform: 'uppercase' }}>
                  Error al generar el token:
                </div>
                <div>
                  {error.includes('email ya está registrado') ? (
                    <>
                      Este email ya está registrado en el sistema.
                      <br />
                      Por favor, utiliza otro email o inicia sesión si ya tienes una cuenta.
                    </>
                  ) : error.includes('Error de configuración') ? (
                    <>
                      Ha ocurrido un error en el servidor.
                      <br />
                      Por favor, inténtalo de nuevo más tarde.
                    </>
                  ) : (
                    error
                  )}
                </div>
              </div>
            )}

            <div style={{ display: 'flex', gap: '0.5rem', justifyContent: 'center' }}>
              <button
                type="button"
                disabled={isSubmitting}
                className={styles.accessButton}
                onClick={(e) => {
                  e.preventDefault();
                  console.log('Submit button clicked, calling handleSubmit');
                  handleSubmit(e);
                }}
              >
                {isSubmitting ? (
                  <>
                    <span className={styles.loadingSpinner} />
                    PROCESANDO...
                  </>
                ) : (
                  'OBTENER TOKEN GRATUITO'
                )}
              </button>
              <button
                type="button"
                onClick={onClose}
                disabled={isSubmitting}
                className={styles.cancelButton}
              >
                CANCELAR
              </button>
            </div>
          </form>

          <ul className={styles.featureList}>
            <li>✓ Acceso inmediato a todos los tests</li>
            <li>✓ Corrección instantánea y explicaciones</li>
            <li>✓ Seguimiento personalizado</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default DirectTokenPurchaseModal;